import { Link } from "react-router-dom";
import { comics } from "@/mocks/comics";
import SectionTitle from "@/components/feature/SectionTitle";

export default function HotRanking() {
  const hot = [...comics].sort((a, b) => b.views - a.views).slice(0, 6);
  const rankColors = [
    "bg-primary-500",
    "bg-secondary-500",
    "bg-accent-500",
    "bg-foreground-400",
    "bg-foreground-400",
    "bg-foreground-400",
  ];

  return (
    <section className="section-pad">
      <div className="container-x">
        <SectionTitle
          kicker="Hot Ranking"
          title="人气飙升榜 TOP6"
          desc="根据收藏与阅读热度实时更新的热门韩漫排行，看看大家都在追什么。"
          moreTo="/category/all"
          moreLabel="完整榜单"
        />

        <div className="grid gap-4 md:grid-cols-2">
          {hot.map((comic, i) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="group flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-3 transition-all duration-300 hover:border-primary-200 hover:bg-primary-50/40"
            >
              <span
                className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-md text-sm font-bold text-background-50 ${rankColors[i]}`}
              >
                {i + 1}
              </span>
              <div className="h-16 w-12 shrink-0 overflow-hidden rounded">
                <img
                  src={comic.cover}
                  alt={`人气第${i + 1}：${comic.title}韩漫封面`}
                  loading="lazy"
                  className="h-full w-full object-cover object-top"
                />
              </div>
              <div className="min-w-0 flex-1">
                <h3 className="truncate text-sm font-semibold text-foreground-950 transition-colors group-hover:text-primary-600">
                  {comic.title}
                </h3>
                <p className="mt-0.5 truncate text-xs text-foreground-500">{comic.author}</p>
                <div className="mt-1 flex items-center gap-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-star-fill text-secondary-500" />
                    {comic.rating.toFixed(1)}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line" />
                    {comic.views}万
                  </span>
                  <span className="truncate">{comic.chapters}话</span>
                </div>
              </div>
              <i className="ri-arrow-right-s-line text-xl text-foreground-300 transition-transform group-hover:translate-x-1" />
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}